<template>
  <div class="qr">
    <div id="qrcode" ref="qrCodeUrl"></div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      // staffId:''
    };
  },
  props:{
    staffId: {
      type: Number,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return null
      }
    },
    avatarName:{
      type:String,
      default: function () {
        return null
      }
    }
  },
  watch:{
    staffId:{ //监听的对象
        deep:true, //深度监听设置为 true
        handler:function(){
            if(this.staffId){
                this.creatQrCode()
            }
        }
    }
    },
  methods: {
    // getStaffs(){
    //   let id=localStorage.getItem("userid")
    //   this.$http.get(this.$api.getStaffs,{userId:id}).then(res=>{
    //     console.log('111',res.data);
    //     let staffId=res.data.id
    //     this.creatQrCode(staffId);
    //   })
    // },
    // 生成二维码页面
    creatQrCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: process.env.VUE_APP_BASE_URL+'homePage?phoneNo='+localStorage.getItem('phone'), //生成二维码的内容（链接或者其他）
        width: 200, //生成的二维码的宽度
        height: 200, //生成的二维码的高度
        colorDark : "#000000", // 生成的二维码的深色部分
        colorLight : "#ffffff", //生成二维码的浅色部分
        correctLevel : QRCode.CorrectLevel.L,//纠错等级
        background : "#ee0a24",//背景颜色
        foreground : "#cb0aee",//前景颜色
      });
    },

  },
  mounted() {
    if(this.staffId){
        this.creatQrCode()
    }
    // this.getStaffs()
  },
};
</script>
<style lang="less" scoped>
#qrcode {
  width: 67.5px;
  height: 67.5px;
  background: #fff;
  padding: 1.5px;
  /deep/ img {
    width: 100% !important;
    height: 100% !important;
  }
  /deep/ canvas{
    width: 100% !important;
    height: 100% !important;
  }
}

</style>
